import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { EntityType } from '../../../../../../../pipes/entity-type.pipe';

@Injectable()
export class MunicipalWasteDisposalBaseInfoForm extends AppForm {

  public submissionPurposeOptions: string[] = [
    'Złożenie informacji',
    'Korekta informacji'
  ];

  public propertyTypeOptions: string[] = [
    'Nieruchomości zamieszkałe',
    'Nieruchomości letniskowe'
  ];

  public entityKindOptions: string[] = [
    'Administrator',
    'Właściciel',
    'Posiadacz',
    'Użytkownik',
    'Dzierżawca',
    'Władający',
    'Użytkownik wieczysty',
    'Inny',
    'Posiadacz zależny',
    'Współwłaściciel',
    'Współużytkownik wieczysty',
    'Współdzierżawca',
    'Współposiadacz',
    'Współposiadacz zależny',
    'Lokator'
  ];

  public applyingOptions: string[] = [
    'Osoba fizyczna',
    'Osoba prawna'
  ];

  constructor() {
    super({
      applyingAs: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      propertyType: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      submissionPurpose: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      entityKind: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      })
    });
    this.propertyType.setValue(this.propertyTypeOptions[0]);
    this.submissionPurpose.setValue(this.submissionPurposeOptions[0]);
    this.entityKind.setValue(this.entityKindOptions[0]);
  }

  public get entityKind(): FormControl {
    return this.get('entityKind') as FormControl;
  }

  public get propertyType(): FormControl {
    return this.get('propertyType') as FormControl;
  }

  public get submissionPurpose(): FormControl {
    return this.get('submissionPurpose') as FormControl;
  }
}
